import { installTypes } from "@/mocks/serviceInstalacionData";

export default function InstallTypes() {
  return (
    <section className="py-12 md:py-20 px-4 md:px-8 lg:px-12 bg-background-100">
      <div className="max-w-6xl mx-auto">
        <div className="reveal mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-[#0087a4] mb-2 leading-tight">
            Tipos de aires acondicionados que instalamos
          </h2>
        </div>

        <ul className="space-y-4 md:space-y-5">
          {installTypes.map((type, i) => (
            <li
              key={type.name}
              className="reveal flex items-start gap-3 md:gap-4"
              style={{ transitionDelay: `${i * 80}ms` }}
            >
              <div className="w-5 h-5 rounded-full bg-[#0087a4] flex items-center justify-center shrink-0 mt-0.5">
                <i className="ri-check-line text-white text-xs" />
              </div>
              <div>
                <span className="text-[#0087a4] font-bold text-sm md:text-base uppercase tracking-wide">
                  {type.name}
                </span>
                <span className="text-foreground-600 text-sm md:text-base ml-2">
                  - {type.tagline}
                </span>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}